import { defineEnv } from '@dcs/config/env';
import { z } from 'zod';

const schema = z.object({
  SITE_URL: z
    .url()
    .default('http://localhost:4321')
    .describe('Public URL of the site (Astro, Cloudflare Pages), see docs/services.md'),
  APP_URL: z
    .url()
    .default('http://localhost:5173')
    .describe('Public URL of this app (Cloudflare Pages), see docs/services.md'),
  API_URL: z
    .url()
    .default('http://localhost:8787')
    .describe('Public URL of the API Worker, see docs/services.md'),
});

/** Values are injected by `vite.config.ts` (`define`); all are optional so the build needs no env. */
export const env = defineEnv(schema, {
  SITE_URL: import.meta.env.SITE_URL,
  APP_URL: import.meta.env.APP_URL,
  API_URL: import.meta.env.API_URL,
});
